<template>
    <v-row no gutters>
        <v-col>
            <v-list subheader :style="'height: 50vh; overflow: auto'" lines="two">
                <v-list-subheader>
                    Sélectionnez le tag à conserver pour la fusion
                </v-list-subheader>
                <v-list-item
                    v-for="tag in tagsToMerge"
                    :key="tag.id"
                    class="mb-2"
                    @click="selectToKeepTag(tag)"
                    density="compact"
                    rounded="xl"
                    border
                    lines="two"
                >
                    <v-list-item-title style="text-overflow: ellipsis; max-width: 600px">
                        {{ tag.name }}
                    </v-list-item-title>
                    <template v-slot:append class="my-0">
                        <v-btn-icon
                            color="primary"
                            :icon="
                                tag.id === toKeepTag.id
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            "
                        >
                        </v-btn-icon>
                    </template>
                </v-list-item>
                <!-- <v-list-item class="my-1" style="background: #fff" v-if="toMergeCompaniesLoading">
                    <template class="py-0">
                        <v-skeleton-loader
                            ref="skeleton"
                            type="list-item-three-line"
                        ></v-skeleton-loader>
                    </template>
                </v-list-item> -->
            </v-list>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import TAGS_MERGE from "../../graphql/tag/TagsMerge.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["tags-merged"],
})
export class MergeTags extends Vue {
    @Prop({ default: [] }) tagsToMerge: Array<any>;
    @Prop({ default: null }) companyId: string;
    @Prop({ default: null }) actions: any;

    toKeepTag: any = {};
    toMergeTags = [];
    selectToKeepTag(tag) {
        this.toKeepTag = tag;
    }

    beforeMount() {
        if (this.actions?.action) {
            this.actions.action.function = this.tagsMerge;
            this.actions.action.disabled = () => {
                return !this.toKeepTag?.id;
            };
            this.actions.action.hideValid = false;
            this.actions.action.title = "Valider la fusion";
        }
    }

    @Watch("toKeepTag")
    onToKeepTagChange() {
        if (this.toKeepTag?.id) {
            this.toMergeTags = this.tagsToMerge.filter((tag) => tag.id !== this.toKeepTag.id);
        } else {
            this.toMergeTags = [];
        }
    }

    async tagsMerge() {
        if (this.companyId && this.toKeepTag?.id && this.toMergeTags?.length) {
            try {
                const mergedTags = await this.$apollo.mutate({
                    mutation: TAGS_MERGE,
                    variables: {
                        toKeepTagId: this.toKeepTag.id,
                        toMergeTagIds: this.toMergeTags.map((tag) => tag.id),
                        companyId: this.companyId,
                    },
                });
                if (mergedTags?.data?.tagsMerge) {
                    this.$emit("tags-merged", mergedTags.data.tagsMerge);
                }
            } catch (e) {
                console.error(e);
            }
        }
    }
}

export default toNative(MergeTags);
</script>
